import { Component } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';


@Component({
  selector: 'app-privacy-page',
  templateUrl: './privacy-page.component.html',
  styleUrls: ['./privacy-page.component.scss']
})
export class PrivacyPageComponent {

  logo;
  immagine;
  testata_colore = '#fff';

  approvazioni_completate = false;
  privacy_policy = false;
  disable_page = true;
  confirm_page = false;
  disabilita_campi = false;

  dati;
  chiave;
  numero_approvazioni_totali;
  error_message_string = '';
  confirm_message_string;
  testo_policy = '';

  constructor(private route: ActivatedRoute, private http: HttpClient) {

    this.route.queryParams.subscribe(params => {
      if (params['param'] !== '') {
        this.chiave = params['param'];
        this.getParams(params['param']);
      }
    });

  }

  sottoscrivi() {

    this.approvazioni_completate = false;

    let approvazioni;
    approvazioni = [];

    for (let i = 0; i < this.dati.approvazioni.length; i++ ) {
      // approvazioni.push( {'ord': Number(this.dati.approvazioni[i].ord), 'value': Number(this.dati.approvazioni[i].model) });
      approvazioni[Number(this.dati.approvazioni[i].ord)] = Number(this.dati.approvazioni[i].model);
    }

    this.http.post('https://privacy.shock-wave.it/script/request.php?operazione=wssetapprovazioni',
      {key: this.chiave, approvazioni: approvazioni }).subscribe(res => {
        if (res['success']) {
          // this.disable_page = true;
          this.disabilita_campi = true;
          this.confirm_page = true;
          this.confirm_message_string = res['msg'];
        } else {
          // this.disable_page = true;
          this.disabilita_campi = true;
          this.confirm_page = false;
          this.error_message_string = res['msg'];
        }
    },
    error => {
      this.disabilita_campi = true;
      this.confirm_page = false;
      this.error_message_string = 'Si è verificato un errore con il server.';
    });

  }

  getParams(params) {
    this.http.get('https://privacy.shock-wave.it/script/request.php?operazione=wsgetlanding&key=' + params).toPromise().then(res => {
      if (res['success']) {

        let approvazioni;
        approvazioni = [];

        for (let prop in res['msg'].approvazioni) {

          let model;

          if(res['msg'].approvazioni[Number(prop)].predefinito == false && res['msg'].approvazioni[Number(prop)].predefinito !== 'null' && res['msg'].approvazioni[Number(prop)].predefinito !== null ) {
            model = '0';
          } else if (res['msg'].approvazioni[Number(prop)].predefinito == true) {
            model = '1';
          } else {
            model = '';
          }

          approvazioni.push({'ord': Number(res['msg'].approvazioni[Number(prop)].ord ), 
            'desc_lunga': res['msg'].approvazioni[Number(prop)].desc_lunga, 
            'model': model }); 
        }

        this.dati = res['msg'];
        this.dati.approvazioni = approvazioni;

        if (this.dati.background_rgb !== '') {
          this.testata_colore = this.dati.background_rgb;
        }

        this.logo = this.dati.logo;

        if (this.dati.background_rgb !== '') {
          this.immagine = this.dati.img_intro;
        }
        this.testo_policy = this.dati.testo_policy;
        this.numero_approvazioni_totali = this.dati.approvazioni.length;
        this.disable_page = false;
        this.contaApprovazioni();

      } else {
        this.error_message_string = res['msg'];
      }
    },
    error => {
      this.error_message_string = 'Si è verificato un errore con il server.';
    });
  }

  contaApprovazioni() {
    let numero_approvazioni_approvate = 0;
    for (let i = 0; i < this.dati.approvazioni.length; i++ ) {
      if (this.dati.approvazioni[i].model !== '' ) {
        numero_approvazioni_approvate ++;
      }
    }
    if (numero_approvazioni_approvate === this.numero_approvazioni_totali) {
      this.approvazioni_completate = true;
    } else {
      this.approvazioni_completate = false;
    }
  }

  rimuoviApprovazioni() {
    if (this.privacy_policy === false) {
      for (let i = 0; i < this.dati.approvazioni.length; i++ ) {
        this.dati.approvazioni[i].model = '';
      }
      this.contaApprovazioni();
    }
  }

  onReadPrivacy() {

    // this.popup.options = {
    //   header: 'Privacy Policy',
    //   animation: 'fadeInDown',
    //   color: this.testata_colore,
    //   cancleBtnContent: 'OK',
    //   cancleBtnClass: 'btn btn-primary bottone',
    //   confirmBtnClass: 'disabled-button'
    // };

    // this.popup.show();
  }

}



// WEBPACK FOOTER //
// /Users/andrea/Documents/Projects/SW40/landing-portale-privacy/src/app/privacy-page/privacy-page.component.ts